"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROW_WRAPPER_CLASS = void 0;
var _lodestarUtils = require("@smartsheet/lodestar-utils");
const GROW_WRAPPER_CLASS = (0, _lodestarUtils.genId)("textarea-grow-wrapper");
exports.GROW_WRAPPER_CLASS = GROW_WRAPPER_CLASS;
//# sourceMappingURL=constants.js.map